import { observer } from "mobx-react";
import * as React from "react";
import { AudioNodeStore, NodeCollectionStore, NodeStore, StoreType } from "../../../stores";
import { TextNodeView } from "../TextNodeView/TextNodeView";
import { VideoNodeView } from "../VideoNodeView/VideoNodeView";
import { ImageNodeView } from "../ImageNodeView/ImageNodeView";
import { WebNodeView } from "../WebNodeView/WebNodeView";
import { AudioNodeView } from "../AudioNodeView/AudioNodeView";
import { TopBar } from "../TopBar";
import { ResizableNodeView } from "../ResizableNodeView";
import "./NodeCollectionView.scss";

@observer
export class NodeCollectionView extends ResizableNodeView<NodeCollectionStore> {

    /**
     * This getter method returns the CSS class name for the collection node.
     * Used for nesting collections within collections.
     * @returns Class name for the collection node container.
     */
    protected getNodeClassName(): string {
        return "collection-node";
    }

    /**
     * This method renders a node based on its type.
     * @param node The node to render.
     * @returns The rendered node view.
     */
    private renderNode(node: NodeStore): React.ReactNode {
        switch (node.type) {
            case StoreType.Text:
                return <TextNodeView key={node.Id} store={node as any} />;

            case StoreType.Video:
                return <VideoNodeView key={node.Id} store={node as any} />;

            case StoreType.Image:
                return <ImageNodeView key={node.Id} store={node as any} />;

            case StoreType.Web:
                return <WebNodeView key={node.Id} store={node as any} />;
            case StoreType.Audio:
                return <AudioNodeView key={node.Id} store={node as AudioNodeStore} />;
            case StoreType.Collection:
                return (
                    <NodeCollectionView
                        key={node.Id}
                        store={node as NodeCollectionStore}
                    />
                );

            default:
                return null;
        }
    }

    /**
     * This method renders the visual content of the node collection, 
     * including the top bar and contained nodes.
     * @returns The rendered node collection content.
     */
    protected renderContent(): React.ReactNode {
        const store = this.props.store;

        return (
            <>
                <TopBar store={store} />

                <div
                    className={
                        store.isGridView
                            ? "content grid-view"
                            : "content scroll-box"
                    }
                >
                    {store.nodes.map(node => this.renderNode(node))}
                </div>
            </>
        );
    }
}